module.exports = "/assets/56fe554fe866d741d30ad73081f5de09.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/EI.png
// module id = 2463
// module chunks = 0